import React from "react";
import {
  Offer,
  TemplateOptionSettings,
  Template,
  CampaignType,
} from "../../../../../types/global.types";
import FeaturedForMultiple from "../FeaturedForMultiple/FeaturedForMultiple";
import "./style.scss";

interface Props {
  featuredOffers: Offer[];
  settings: TemplateOptionSettings;
  settingsTemplate: Template;
  displayOnly: boolean;
  campaignId: string;
  placementId: string;
  placementName: string;
  campaign: CampaignType;
  preEmail: string | undefined;
  setPreEmail?: (email: string) => void;
  openSingle: (
    o: Offer,
    isSave: boolean,
    isAutoEmail: boolean,
    slot: number,
    isShare?: boolean
  ) => void;
  onAdd: (offer: Offer, value: boolean, slot: number) => void;
  layoutId: string;
  canAutoSendEmailFromLabel?: boolean;
  canAutoSendEmailFromMainCTA?: boolean;
  onAutoSendEmailFromLabel?: (offer: Offer, slot: number) => void;
  autoSendingOfferId?: string;
}

export const MultipleFeaturedWrapperDesktop = ({
  featuredOffers,
  preEmail,
  setPreEmail,
  settings,
  campaign,
  settingsTemplate,
  displayOnly,
  campaignId,
  placementId,
  placementName,
  openSingle,
  onAdd,
  layoutId,
  canAutoSendEmailFromLabel,
  canAutoSendEmailFromMainCTA,
  onAutoSendEmailFromLabel,
  autoSendingOfferId,
}: Props) => {
  const hasAnyVoucherWithType = (offers: Offer[]): boolean => {
    return offers.some(
      (featuredOffer) =>
        featuredOffer.voucher && !!featuredOffer.voucher.voucherType
    );
  };

  return (
    <div
      className={`super-desktop-featured-wrapper ${
        featuredOffers.length > 1
          ? "super-desktop-multiple"
          : "super-desktop-single"
      }`}
    >
      {featuredOffers.map((featuredOffer) => (
        <React.Fragment key={featuredOffer.id}>
          <FeaturedForMultiple
            slot={featuredOffer.slot}
            settingsTemplate={settingsTemplate}
            otherSettings={settings.otherSettings}
            campaignId={campaignId}
            placementId={placementId}
            placementName={placementName}
            offer={featuredOffer}
            offerLength={campaign.offers.length}
            settings={settings}
            openSingle={openSingle}
            onAdd={onAdd}
            setPreEmail={setPreEmail}
            preEmail={preEmail}
            displayOnly={displayOnly}
            campaign={campaign}
            isAdded={featuredOffer.isAdded || false}
            retailerId={campaign.company_Id}
            hasVoucher={
              (featuredOffer.voucher && !!featuredOffer.voucher.voucherType) ||
              false
            }
            hasAnyVoucherWithType={hasAnyVoucherWithType(featuredOffers)}
            layoutId={layoutId}
            layoutOptions={settings?.layoutOptions}
            canAutoSendEmailFromLabel={canAutoSendEmailFromLabel}
            canAutoSendEmailFromMainCTA={canAutoSendEmailFromMainCTA}
            onAutoSendEmailFromLabel={onAutoSendEmailFromLabel}
            autoSendingOfferId={autoSendingOfferId}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
